"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WaveDropContent from "@/components/waves/drops/WaveDropContent";
import WaveDropMetadata from "@/components/waves/drops/WaveDropMetadata";
import { useRouter } from "next/navigation";
import WaveDropReactions from "@/components/waves/drops/WaveDropReactions";
import type { DropContentPresentation } from "@/components/waves/drops/dropContentPresentation";
import { getDropIdentityProfile, getDropVisibleMetadata } from "@/components/waves/drops/identityDisplay.helpers";
import { areSameProfileIdentity } from "@/helpers/ProfileHelpers";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import { WaveLeaderboardIdentity } from "../identity/WaveLeaderboardIdentity";
interface WaveLeaderboardDropContentProps {
  readonly drop: ExtendedDrop;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly contentPresentation?: DropContentPresentation | undefined;
}
export const WaveLeaderboardDropContent: React.FC<WaveLeaderboardDropContentProps> = t0 => {
  const $ = _c(27);
  const {
    drop,
    isCompetitionDrop: t1,
    contentPresentation: t2
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  const contentPresentation = t2 === undefined ? "default" : t2;
  const router = useRouter();
  const [activePartIndex, setActivePartIndex] = useState(0);
  let t3;
  if ($[0] !== drop.metadata || $[1] !== drop.wave) {
    t3 = getDropVisibleMetadata({
      wave: drop.wave,
      metadata: drop.metadata
    });
    $[0] = drop.metadata;
    $[1] = drop.wave;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const visibleMetadata = t3;
  let t4;
  if ($[3] !== drop.author || $[4] !== drop.metadata || $[5] !== drop.wave) {
    const identityProfile = getDropIdentityProfile({
      wave: drop.wave,
      metadata: drop.metadata
    });
    t4 = identityProfile ? areSameProfileIdentity({
      left: drop.author,
      right: identityProfile
    }) : false;
    $[3] = drop.author;
    $[4] = drop.metadata;
    $[5] = drop.wave;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const isSelfNominee = t4;
  let t5;
  if ($[7] !== router) {
    t5 = clickedDrop => {
      const href = getWaveRoute({
        waveId: clickedDrop.wave.id,
        serialNo: clickedDrop.serial_no,
        isDirectMessage: false,
        isApp: false
      });
      router.push(href);
    };
    $[7] = router;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const onDropContentClick = t5;
  let t6;
  if ($[9] !== activePartIndex || $[10] !== contentPresentation || $[11] !== drop || $[12] !== isCompetitionDrop || $[13] !== onDropContentClick) {
    t6 = <WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onDropContentClick={onDropContentClick} onLongPress={_temp} onQuoteClick={_temp2} setLongPressTriggered={_temp3} isCompetitionDrop={isCompetitionDrop} contentPresentation={contentPresentation} />;
    $[9] = activePartIndex;
    $[10] = contentPresentation;
    $[11] = drop;
    $[12] = isCompetitionDrop;
    $[13] = onDropContentClick;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = !isSelfNominee;
  let t8;
  if ($[15] !== drop || $[16] !== t7) {
    t8 = <WaveLeaderboardIdentity drop={drop} variant="responsive" cardVariant="chat" className="tw-mt-2 lg:tw-mt-0" showIdentityHeader={t7} />;
    $[15] = drop;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== visibleMetadata) {
    t9 = !!visibleMetadata.length && <WaveDropMetadata metadata={visibleMetadata} />;
    $[18] = visibleMetadata;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== drop) {
    t10 = <div className="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1"><WaveDropReactions drop={drop} /></div>;
    $[20] = drop;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t6 || $[24] !== t8 || $[25] !== t9) {
    t11 = <div className="-tw-mt-0.5 tw-flex tw-flex-col tw-gap-y-1">{t6}{t8}{t9}{t10}</div>;
    $[22] = t10;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
function _temp() {}
function _temp2() {}
function _temp3() {}